<template>
    <div class="detail">
      <a-page-header :title="isAdd ? '新建资讯' : '修改资讯'" @back="goback" />
      <a-form layout="horizontal" :form="form" ref="form" class="po-inner">
        <!-- 新闻类型 -->
        <a-form-item
          label="资讯类型"
          :labelCol="{ lg: { span: 2 } }"
          :wrapperCol="{ lg: { span: 9 } }"
        >
          <a-select
            :disabled="!isAdd"
            @change="change"
            class="form-cell"
            style="width:260px"
            placeholder="请选择"
            v-decorator="[
              'type',
              {
                rules: [{ required: true, message: '请选择资讯类型' }],
                validateTrigger: 'change',
              },
            ]"
          >
            <a-select-option v-for="(item) in tabs" :value="item.id" :key="item.id">{{
              item.tagName
            }}</a-select-option>
          </a-select>
        </a-form-item>
  
        <!-- 资讯标题 -->
        <a-form-item label="标题" :spellcheck="false" :labelCol="{ lg: { span: 2 } }" :wrapperCol="{ lg: { span: 9 } }">
          <a-input
            type="text"
            placeholder="请输入"
            style="width:260px"
            v-decorator="[
              'title',
              {
                rules: [{ required: true, message: '请输入资讯标题' }],
                validateTrigger: 'change',
              },
            ]"
          />
        </a-form-item>
        <!-- 生效时间 -->
        <a-form-item
          label="生效时间"
          :labelCol="{ lg: { span: 2 } }"
          :wrapperCol="{ lg: { span: 18 } }"
        >
          <div style="display:flex; width:520px">
            <a-date-picker
              v-if="tiemnull"
              style="width:calc(50% - 12px)"
              :getCalendarContainer="triggerNode => triggerNode.parentNode"
              format="YYYY-MM-DD HH:mm:ss"
              :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              placeholder="请选择时间"
              @change="onChange"
              @ok="ok1"
            />
            <a-date-picker
              v-else
              style="width:calc(50% - 12px)"
              :getCalendarContainer="triggerNode => triggerNode.parentNode"
              format="YYYY-MM-DD HH:mm:ss"
              :defaultValue="showBeginTime?moment(showBeginTime, 'YYYY-MM-DD HH:mm:ss'):''"
              :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              placeholder="请选择时间"
              @change="onChange"
              @ok="ok1"
            />
  
            <span style="display:block; width:24px; text-align: center; height:32px; line-height:32px"
              >-</span
            >
            <a-date-picker
              v-if="tiemnull"
              style="width:calc(50% - 12px)"
              :getCalendarContainer="triggerNode => triggerNode.parentNode"
              format="YYYY-MM-DD HH:mm:ss"
              :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }"
              placeholder="请选择时间"
              @change="onChange2"
              @ok="ok2"
            />
            <a-date-picker
              v-else
              style="width:calc(50% - 12px)"
              :getCalendarContainer="triggerNode => triggerNode.parentNode"
              format="YYYY-MM-DD HH:mm:ss"
              :defaultValue="showEndTime?moment(showEndTime, 'YYYY-MM-DD HH:mm:ss'):''"
              :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }"
              placeholder="请选择时间"
              @change="onChange2"
              @ok="ok2"
            />
          </div>
          <p v-if="tips" style="color:#ff0000">* 开始时间不能大于结束时间</p>
        </a-form-item>
        <a-form-item
          label="资讯内容"
          :labelCol="{ lg: { span: 2 } }"
          :wrapperCol="{ lg: { span: 18 } }"
        >
          <!-- <a-textarea
            type="text"
            class="textarea-input"
            placeholder="请输入"
            v-decorator="[
              'content',
              {rules: [{ required: true, message: '请输入资讯类型' }], validateTrigger: 'change'}
            ]"
          />-->
          <c-richtext
            style="width:800px; height:500px"
            :editorContent.sync="editorContent"
          ></c-richtext>
        </a-form-item>
        <div style="padding-left:8.3%">
          <a-button type="primary" v-if="isAdd" :disabled="disabled" @click="handleSubmit"
            >保存</a-button
          >
          <a-button type="primary" v-else :disabled="disabled" @click="handleSubmit"
            >确认修改</a-button
          >
        </div>
      </a-form>
    </div>
  </template>
  <script>
  import news from '../../api/news'
  // import CUpload from '../../components/CUpload'
  import CRichtext from '../../components/CRichtext'
  import moment from 'moment'
  import { log } from 'util'
  export default {
    name: 'list/manage',
    data() {
      return {
        disabled: false,
        form: this.$form.createForm(this),
        isAdd: true, //是否是新增person
        tiemnull: true,
        newsId: -1,
        tabsId:'',
        updateData: {},
        confirmLoading: false,
        coverUrl: '',
        sourceFileList: [],
        tabs: [],
        pagination:{},
        title:'',
        portalTypeList: [
          { id: '1', name: '放假' },
          { id: '2', name: '调课' },
          { id: '3', name: '报名' },
          { id: '4', name: '活动' },
        ],
        editorContent: '', //编辑器内容
        show: false,
        showBeginTime: '',
        showEndTime: '',
        VerifyPicture: false,
        tips: false,
      }
    },
    components: {
      // CUpload,
      CRichtext,
    },
    created() {
      this.init(this.$route.query)
      setTimeout(() => {
        this.form.setFieldsValue({ test: 'Invalid code' })
      }, 100)
    },
    methods: {
      // 比较时间大小
      bijiao(time01, time02) {
        console.log('开始时间：', time01)
        console.log('结束时间', time02)
        var now = new Date(time01)
        var end = new Date(time02)
        if (now - end > 0) {
          this.tips = true
        } else {
          this.tips = false
        }
        console.log(this.tips)
      },
      moment,
      ok1(value) {
        if (this.showEndTime != undefined || this.showEndTime != '') {
          this.bijiao(this.showBeginTime, this.showEndTime)
        }
      },
      ok2(value) {
        if (this.showBeginTime != undefined || this.showBeginTime != '') {
          this.bijiao(this.showBeginTime, this.showEndTime)
        }
      },
      change(value) {
        if (value == 3) {
          this.show = true
        } else {
          this.show = false
        }
      },
      onChange(value, dateString) {
        this.showBeginTime = dateString
        if (this.showEndTime != undefined || this.showEndTime != '') {
          this.bijiao(dateString, this.showEndTime)
        }
      },
      onChange2(value, dateString) {
        this.showEndTime = dateString
        this.bijiao(this.showBeginTime, dateString)
      },
      //   返回上一级
      goback() {
        this.$router.go(-1)
      },
      //头像上传成功之后回调
      uploadSuccess(url) {
        console.log(url)
  
        if (this.show) {
          let img = new Image()
          img.src = url
          const vm = this
          img.onload = function() {
            if (img.width == 1280 && img.height == 1110) {
              vm.coverUrl = url
              vm.VerifyPicture = true
              console.log('图片路径001', vm.coverUrl)
              vm.disabled = false
            } else {
              vm.$message.warning('仅支持 1280*1110 大小的图片')
              vm.disabled = true
            }
          }
        } else {
          this.coverUrl = url
          console.log('图片路径002', this.coverUrl)
        }
      },
  
      //初始化，显示
      init(params) {
        console.log('params3333',params)
        
        console.log('this.tabs',this.tabs)
        //初始化form表单数据
        if (JSON.stringify(params.id)) {
          this.isAdd = false
          this.updateData = params
          console.log(params)
          this.pagination = JSON.parse(params.pagination)
          let formData = {}
          formData.title = params.title?params.title:''
          this.title = params.titleTwo?params.titleTwo:'' 
          formData.type = params.typeTagId ? Number(params.typeTagId) : ''
          this.tabsId = params.tabsId ? Number(params.tabsId) : ''
          this.editorContent = params.content
          this.sourceFileList = [params.coverUrl]
          this.coverUrl = params.coverUrl
  
          if (params.showBeginTime != undefined || params.showEndTime != undefined) {
            console.log('进来了吗',params.showBeginTime,params.showEndTime, params.showEndTime? params.showEndTime : null)
            this.showBeginTime = params.showBeginTime ? params.showBeginTime : null
            this.showEndTime = params.showEndTime ? params.showEndTime : ''
            console.log(this.showEndTime,'33333')
            this.tiemnull = false
          } else {
            this.tiemnull = true
          }
          if (params.type != 3) {
            this.show = false
          } else {
            this.show = true
          }
          this.newsId = params.id
          setTimeout(() => {
            this.form.setFieldsValue(formData)
          }, 100)
        } else {
          this.showBeginTime = ''
          this.showEndTime = ''
          this.sourceFileList = []
          this.form.resetFields()
          this.editorContent = ''
        }
        this.tabs = JSON.parse(params.tabsTwo)
      },
  
      //隐藏
      handleCancel() {
        this.$emit('closeForm')
      },
  
      //新增保存
      handleSubmit(e) {
        console.log(this.disabled, 'disabled')
  
        // e.preventDefault();
        this.form.test = '无效内容'
        this.form.validateFields((err, value) => {
          // 校验通过
          if (!err) {
            console.log('this.coverUrl', this.coverUrl)
            value.content = this.editorContent
            if (this.showEndTime == undefined) {
              this.showEndTime = ''
            }
            if (this.showBeginTime == undefined) {
              this.showBeginTime = ''
            }
            value.typeTagId =  value.type
            delete value.type
            value.showEndTime = this.showEndTime
            value.showBeginTime = this.showBeginTime
            this.bijiao(value.showBeginTime, value.showEndTime)
            if (!this.tips) {
              if (this.isAdd) {
                this.addNews(value)
              } else {
                this.updateNews(value)
              }
            }
  
            // if(this.VerifyPicture){
            //     console.log("1111");
  
            // }else{
            //      console.log("222");
            //     this.$message.warning("请重新上传图片");
            // }
          }
        })
        // this.$refs["coverUrl"].check().then(res => {
        //   if (res) {
        //     console.log("this.form",this.form);
        //     // value.coverUrl = this.from.coverUrl;
  
        //   }
        // });
      },
  
      //新增保存接口
      addNews(value) {
        // if (value.type == 3) {
        //   let img = new Image()
        //   img.src = value.coverUrl
        //   const vm = this
        //   img.onload = function() {
        //     if (img.width == 1280 && img.height == 1110) {
        //       news.createNews(value).then(res => {
        //         vm.$message.success('新增成功')
        //         vm.goback()
        //         vm.handleCancel()
        //         vm.$emit('refreshNews')
        //       })
        //     } else {
        //       vm.$message.warning('仅支持 1280*1110 大小的图片')
        //     }
        //   }
        // } else {
          news.createNews(value).then(res => {
            this.$message.success('新增成功')
            // this.goback()
            this.handleCancel()
            this.$emit('refreshNews',this.type)
            this.$router.push({ name: 'list', params: {} })
          })
        // }
      },
      // 修改保存接口
      updateNews(value) {
        // if (value.type == 3) {
        //   let img = new Image()
        //   img.src = value.coverUrl
        //   const vm = this
        //   img.onload = function() {
        //     if (img.width == 1280 && img.height == 1110) {
        //       news.updateNews(vm.newsId, value).then(res => {
        //         vm.$message.success('修改成功')
        //         vm.goback()
        //         Object.assign(vm.updateData, value)
        //         vm.handleCancel()
        //       })
        //     } else {
        //       vm.$message.warning('仅支持 1280*1110 大小的图片')
        //     }
        //   }
        // } else {

          news.updateNews(this.newsId, value).then(res => {
            this.$message.success('修改成功')
            // this.goback()
            Object.assign(this.updateData, value)
            this.handleCancel()
            this.$emit('refreshNews',this.type)
            this.$router.push({ name: 'list', params: { tabsId: this.tabsId,pagination:this.pagination,title: this.title} })
          })
        // }
      },
    },
  }
  </script>
  <style scoped>
  .detail {
    background: #ffffff;
    margin: 20px;
    padding: 20px;
  }
  .ant-page-header {
    padding: 0;
  }
  .po-inner {
    padding-top: 24px;
  }
  .xinghao.ant-form-item label {
    display: block !important;
    background: #000 !important;
  }
  </style>
  